import { render, staticRenderFns } from "./InboxPage.vue?vue&type=template&id=3c18da7d&"
import script from "./InboxPage.vue?vue&type=script&lang=js&"
export * from "./InboxPage.vue?vue&type=script&lang=js&"
import style0 from "./InboxPage.vue?vue&type=style&index=0&id=3c18da7d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports